import React, { useContext } from 'react';
import TableWeekContent from '../TableWeekContent';
import {
  Grid,
  Paper,
  Typography,
  Chip,
  Icon,
  IconButton,
} from '@material-ui/core';
import { styles } from './styles';
import ProfessionalDetails from '../ProfessionalDetails';
import { ProfessionalSchedulePageContext } from 'page/Schedule/ProfessionalSchedule/index';

function GridProfessionalSchedule() {
  const classes = styles();

  const {
    dataUnitAgenda,
    loadingAgenda,
    selectedSchedule,
    meta,
    setMainFilter,
    autoSelectedScaleName,
    setAutoSelectedScaleName,
  } = useContext(ProfessionalSchedulePageContext);
  const permissions = {
    value: 'scheduleValue/r',
  };
  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={4} xl={3}>
          <ProfessionalDetails />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={8} xl={9}>
          {autoSelectedScaleName && (
            <div
              className="flex items-center gap-2 px-4 py-2 mb-2 rounded"
              style={{
                background: '#EFF6FF',
                border: '1px solid #BFDBFE',
                marginBottom: 8,
              }}
            >
              <Icon style={{ color: '#2563EB', fontSize: 20 }}>info</Icon>
              <Typography variant="body2" style={{ color: '#1E40AF', flex: 1 }}>
                Mostrando a escala <strong>{autoSelectedScaleName}</strong> —
                primeira do profissional. Selecione outra no filtro se quiser.
              </Typography>
              <IconButton
                size="small"
                onClick={() => setAutoSelectedScaleName(null)}
              >
                <Icon style={{ fontSize: 16 }}>close</Icon>
              </IconButton>
            </div>
          )}
          <Paper elevation={0} className={classes.paper}>
            {dataUnitAgenda &&
              dataUnitAgenda.length > 0 &&
              dataUnitAgenda.map((data, index) => (
                <TableWeekContent
                  permissions={permissions}
                  key={index}
                  data={data}
                  selectedSchedule={selectedSchedule}
                />
              ))}
            {!loadingAgenda &&
              (dataUnitAgenda.length === 0 || !selectedSchedule) && (
                <div className={classes.container_no_results}>
                  {meta?.current_scale_invalid &&
                  meta?.user_scales?.length > 0 ? (
                    <>
                      <Typography className={classes.no_results}>
                        Este profissional não tem agendas na escala selecionada.
                        Escalas dele:
                      </Typography>
                      <div className="flex flex-wrap gap-2 mt-2 justify-center">
                        {meta.user_scales.map((scale) => (
                          <Chip
                            key={scale.id}
                            label={scale.name}
                            clickable
                            onClick={() =>
                              setMainFilter((old) => ({
                                ...old,
                                scale_id: scale.id,
                              }))
                            }
                          />
                        ))}
                      </div>
                    </>
                  ) : (
                    <Typography className={classes.no_results}>
                      Sem registros nesse período.
                    </Typography>
                  )}
                </div>
              )}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

export default GridProfessionalSchedule;
